// tools.js
import Embed from "@editorjs/embed";
import Table from "@editorjs/table";
import List from "@editorjs/list";
import Paragraph from "@editorjs/paragraph";
import Warning from "@editorjs/warning";
import Code from "@editorjs/code";
import LinkTool from "@editorjs/link";
import Image from "@editorjs/image";
import Raw from "@editorjs/raw";
import Header from "@editorjs/header";
import Quote from "@editorjs/quote";
import Marker from "@editorjs/marker";
import CheckList from "@editorjs/checklist";
import Delimiter from "@editorjs/delimiter";
import InlineCode from "@editorjs/inline-code";
import SimpleImage from "@editorjs/simple-image";

export const EDITOR_JS_TOOLS = {
  // NOTE: Paragraph is default tool. Declare only when you want to change paragraph option.
  paragraph: Paragraph,
  embed: Embed,
  table: Table,
  list: List,
  warning: Warning,
  code: Code,
  linkTool: LinkTool,
  image: {
    class: Image,
    config: {
      uploader: {
        uploadByFile(file) {

          // Create FormData object
          const formData = new FormData();
          formData.append("file", file);

          // Make the API request using fetch
          return fetch(process.env.REACT_APP_API_URL + "api/v1/cms/upload-Rawfile", {
            method: "POST",
            headers: {
              'authorization': localStorage.getItem("UserToken"),
            },
            body: formData, // Attach the FormData object
          })
            .then((response) => {
              // Check if the response is okay
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.json(); // Parse JSON response
            })
            .then((data) => {
              if (data.code === 200 && typeof data.filePath === "string") {
                return {
                  success: 1,
                  file: {
                    url: data.filePath,

                  },
                };
              } else {
                throw new Error("Invalid API response format");
              }
            })
            .catch((error) => {
              console.error("Image upload failed:", error);
              return {
                success: 0,
                message: "File upload failed. Please try again.",
              };
            });
        },
      },
    },
  },

  raw: Raw,
  header: Header,
  quote: Quote,
  marker: Marker,
  checklist: CheckList,
  delimiter: Delimiter,
  inlineCode: InlineCode,
  simpleImage: SimpleImage
};
